import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';
import { InputText, InputDate, PassBtn } from '../../../_imports';
import './formation_form.css';

function FormacaoStep({ formData, addFormacao, removeFormacao, handleFormacaoChange, nextStep, prevStep }) {
  const [errors, setErrors] = useState([]);

  const validate = () => {
    let newErrors = [];
    let isValid = true;

    formData.forEach(item => {
      const itemErrors = {};
      if (!item.instituicao.trim()) {
        itemErrors.instituicao = 'Instituição é obrigatória.';
        isValid = false;
      }
      if (!item.curso.trim()) {
        itemErrors.curso = 'Curso é obrigatório.';
        isValid = false;
      }
      if (!item.inicio_form.trim()) {
        itemErrors.inicio_form = 'Data de início é obrigatória.';
        isValid = false;
      }
      newErrors.push(itemErrors);
    });

    setErrors(newErrors);
    return isValid;
  };

  const handleNext = () => {
    if (validate()) {
      nextStep();
    }
  };

  return (
    <fieldset>
      <legend>Formação Acadêmica</legend>

      {formData.map((item, index) => (
        <div key={item.id} className="CardFormacao">
          <div className="CardHeader">
            <h4>Formação #{index + 1}</h4>
            <button
              type="button"
              className="BotaoExcluir"
              onClick={() => removeFormacao(item.id)}
            >
              <FontAwesomeIcon icon={faTrash} /> Excluir
            </button>
          </div>

          <InputText
            label="Instituição de Ensino:"
            id={`instituicao-${item.id}`}
            name="instituicao"
            value={item.instituicao}
            onChange={(e) => handleFormacaoChange(index, e)}
            error={errors[index]?.instituicao}
          />
          <div className='sized-box'></div>
          <InputText
            label="Curso:"
            id={`curso-${item.id}`}
            name="curso"
            value={item.curso}
            onChange={(e) => handleFormacaoChange(index, e)}
            error={errors[index]?.curso}
          /><div className='sized-box'></div>

          <div className="LinhaCampos">
            <InputDate
              label="Data de Início:"
              id={`inicio_form-${item.id}`}
              name="inicio_form"
              value={item.inicio_form}
              onChange={(e) => handleFormacaoChange(index, e)}
              error={errors[index]?.inicio_form}
            />
            <InputDate
              label="Data de Fim (ou previsão):"
              id={`fim_form-${item.id}`}
              name="fim_form"
              value={item.fim_form}
              onChange={(e) => handleFormacaoChange(index, e)}
            />
          </div>
        </div>
      ))}

      <button
        type="button"
        className="BotaoAdicionar"
        onClick={addFormacao}
      >
        <FontAwesomeIcon icon={faPlus} /> Adicionar Formação
      </button>

      <div className="BotoesNavegacao">
        <PassBtn text="Anterior" onClick={prevStep} direction="prev" />
        <PassBtn text="Próximo" onClick={handleNext} direction="next" />
      </div>
    </fieldset>
  );
}

export default FormacaoStep;